module.exports = __webpack_public_path__ + "static/media/XEM.42b04386.svg";